'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require('./actions');

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var socket = io(window.location.origin);

socket.on('connect', function (data) {
  console.log('connected');
});
socket.on('worker', function (data) {
  console.log('worker connected', data);
});
socket.on('updateFile', function (data) {
  console.log('updateFile', data);
  _store2.default.dispatch((0, _actions.updateFile)(data.file));
});
socket.on('updateTask', function (data) {
  console.log('updateTask', data);
  _store2.default.dispatch((0, _actions.updateTask)(data.task));
  if (data.task.output_file) {
    _store2.default.dispatch((0, _actions.addFile)(data.task.output_file));
  }
});

exports.default = socket;


//////////////////
// WEBPACK FOOTER
// ./client/socket.js
// module id = 119
// module chunks = 0